<template>
  <div class="container" :class="{ loading }">
    <img class="colofon" src="@/assets/images/colofon.png" />
    <h3 class="header">
      <i class="icon-volume"/>
      Staat uw geluid aan?
    </h3>
    <main class="main">
      <img class="logo" src="@/assets/images/logo.png" />
      <div class="button" @click="start"></div>
      <h2 class="button-label">begin</h2>
    </main>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { defer } from '@/utils'
import stories from '@/data/stories'

export default {
  name: 'StartView',
  data () {
    return {
      loading: process.env.NODE_ENV === 'production'
    }
  },
  methods: {
    ...mapActions([
      'loadScene',
      'selectStory'
    ]),
    start () {
      this.audio.play()
      this.track('start_session', {
        event_category: 'session'
      })
      defer(100, () => {
        const story = stories[0]
        this.selectStory(story.id)
        const data = { ...story, index: 0 }
        this.loadScene({ name: 'Intro', data })
      })
    }
  },
  created () {
    this.audio = new Audio('audio/ui/click.mp3')
    defer(6000, () => { this.loading = false })
  }
}
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  max-width: $screen-md;
  height: 100%;
  padding: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.colofon {
  position: fixed;
  top: 0;
  right: 0;
  width: 18rem;
}

.header {
  color: $color-white;
  text-transform: uppercase;
  transition: opacity 400ms, transform 400ms;

  i {
    font-size: 4.2rem;
    margin-right: 3rem;
    vertical-align: sub;
  }

  .loading & {
    opacity: 0;
    transform: translateY(-100%);
  }
}

.main {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .logo {
    margin-bottom: 6rem;
    text-transform: uppercase;
    animation: fadeIn 3s ease-in;
  }

  .button {
    @include clickable();
    width: $button-xl;
    height: $button-xl;
    margin-bottom: 1.8rem;
    border-radius: 50%;
    background: $color-white center / 60% no-repeat url('~@/assets/images/footsteps.png');
    box-shadow: 0 0 0 1.2rem transparentize($color-white, .6);
    transition: box-shadow 200ms;
    opacity: 0;
    animation:
      popIn 400ms 1s $easeInOutQuad,
      fadeIn 400ms 1s $easeIn forwards;

    &:hover {
      box-shadow: 0 0 0 1.2rem transparentize($color-white, .4);
    }

    &:active {
      transform: scale(.95);
    }

    .loading & {
      visibility: hidden;
      animation: none;
    }
  }

  .button-label {
    color: $color-white;
    text-transform: uppercase;
    transition: opacity 400ms 1s $easeIn;

    .loading & {
      opacity: 0;
    }
  }
}
</style>
